<template>
  <v-container>
    <v-card class="mx-auto mt-16 py-2 px-6" max-width="400">
      <v-card-item>
        <v-card-title>
          Request access
        </v-card-title>
      </v-card-item>
      <!-- <v-card-text>
        We will periodically be opening access
      </v-card-text> -->
      <v-form>
        <v-text-field
          v-model="email"
          name="email"
          label="Email"
          type="text"
          placeholder="Email"
          variant="outlined"
          required
          :rules="emailRules"
        ></v-text-field>
        <!-- <v-text-field
          v-model="referralCode"
          name="referralCode"
          label="Referral Code"
          type="text"
          placeholder="Referral Code"
          variant="outlined"
        ></v-text-field> -->
      </v-form>
      <v-card-actions>
        <v-btn
          @click="register"
          text="Submit"
          :disabled="registerDisabled()"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script lang="ts">
// import { checkEmail } from '@/utils/general'
import { Options, Vue } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import { useRouter } from 'vue-router'

export function checkEmail(v: string) {
  return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(v)
}
export function checkString(v: string) {
  return /[a-zA-Z0-9]{8}/.test(v)
}

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapState(['username', 'authenticated'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    // authenticated(value: boolean) {
    //   if (value) {
        
    //   }
    // }
  }
})
export default class RegisterView extends Vue {
  public breakpoint!: string
  public authenticated!: boolean
  public email: string = ''
  public referralCode: string = ''
  private router = useRouter()

  public emailRules = [
    (v: string) => !!v || 'Email is required',
    (v: string) => checkEmail(v) || 'Invalid email address.',
  ]

  public referralCodeRules = [
    (v: string) => checkString(v) || 'Invalid referral code.',
  ]

  public async mounted() {
    await this.$store.dispatch('checkAuth')
  }

  public registerDisabled() {
    const email = this.email.trim()
    if (email !== '' && checkEmail(email)) {
      return false
    } else {
      return true
    }
  }
  
  public async register() {
    // sign in here
    const email = this.email.trim()
    const referralCode = this.referralCode.trim()
    if (email !== '') {
      const { success } = await this.$store.dispatch('request', { email, referralCode })
      if (success) {
        await this.router.push('/sign-in')
        console.log(`pushing route to /sign-in`)
      }
    }
  }
}
</script>
<style lang="scss">
.access-text {
  max-width: 400px;
}
</style>